module.exports = __webpack_public_path__ + "static/media/lexus-vial.9f3e4c27.svg";